
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleet as ObiHeavySleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet.js';
 
 
 

 
 export const ObiHeavySleet = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet',
   elementClass: ObiHeavySleetElement,
   events: {
     
   }
  });
 
 